'use client'
import { Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";
import { defaultVisitor, visitorResponseType } from "@/types";
import { SquareCheck, SquareX } from "@/assets/icons";
import { delVisitor, getVisitorId } from "@/app/api";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

export function DeleteVisitor({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [visitorData, setVisitorData] = useState<visitorResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getVisitorId(id)
                if (response !== undefined) {
                    setVisitorData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o visitante: ', e)
            }
        }

        fetchUser()
    }, [id])

    const visitor = visitorData || defaultVisitor

    const deleteVisitor = async () => {
        setLoading(true)
        try {
            const res = await delVisitor(visitor.id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir retorno: ", err);
        } finally {
            setLoading(false);
        }
    }
    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Enviar notificações</TableHeader>
                            <TableHeader colSpan={2}>Data de entrada</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{visitor.sequence}</TableCell>
                            <TableCell>{visitor.name}</TableCell>
                            <TableCell>{visitor.email || 'Não informado'}</TableCell>
                            <TableCell className="flex items-center">
                                {visitor.receiveNotifications
                                    ? <SquareCheck />
                                    : <SquareX />}
                            </TableCell>
                            <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{visitor.sequence}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{visitor.name}</TableCell>
                            <TableHeader>Email</TableHeader>
                            <TableCell>{visitor.email || 'Não informado'}</TableCell>
                            <TableHeader>Enviar notificações</TableHeader>
                            <TableCell className="flex items-center">
                                {visitor.receiveNotifications
                                    ? <SquareCheck />
                                    : <SquareX />}
                            </TableCell>
                            <TableHeader>Data de entrada</TableHeader>
                            <TableCell>{new Date(visitor.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>


            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir esse visitante? Essa ação não poderá ser desfeita."
                onConfirm={deleteVisitor}
                onCancel={() => setOpenMessage(false)}
            />

        </div>
    )
}